import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD } from '../../../../shared/format.js';

/** يحوّل الأيام إلى تسمية مفهومة: 30 = شهر، 90 = 3 أشهر... */
export function durationLabel(days) {
  const d = Math.max(0, Math.round(Number(days) || 0));
  if (d === 0) return '—';
  if (d % 365 === 0) return d === 365 ? 'سنة' : `${d / 365} سنوات`;
  if (d % 30 === 0) return d === 30 ? 'شهر' : `${d / 30} أشهر`;
  return `${d} يوم`;
}

export function PlanCard({ plan, canEdit, onEdit, onDelete }) {
  return (
    <div className="card p-4 flex flex-col gap-2">
      <div className="flex items-start justify-between gap-2">
        <div className="text-[15px] font-bold">{plan.name}</div>
        {plan.isActive === false
          ? <Pill variant="muted">معطّلة</Pill>
          : <Pill variant="success">فعّالة</Pill>}
      </div>
      <div className="text-[12.5px] text-ink-2">
        المدة: {durationLabel(plan.durationDays)} ({plan.durationDays} يوم)
      </div>
      <div className="text-[20px] font-extrabold" style={{ color: '#C2570D' }}>
        {formatIQD(plan.price || 0)}
      </div>
      <div className="text-[11.5px] text-ink-3">دخول غير محدود خلال الفترة — بلا رسوم لعب</div>
      {plan.description ? (
        <div className="text-[12px] text-ink-2 line-clamp-2">{plan.description}</div>
      ) : null}
      {canEdit ? (
        <div className="flex items-center gap-1.5 mt-1">
          <button
            type="button"
            className="btn flex-1 justify-center"
            style={{ padding: '6px 10px', fontSize: 12 }}
            onClick={() => onEdit?.(plan)}
          >
            <Icon name="edit" size={13} /> تعديل
          </button>
          <button
            type="button"
            className="btn btn-danger"
            style={{ padding: '6px 10px', fontSize: 12 }}
            onClick={() => onDelete?.(plan)}
          >
            <Icon name="trash" size={13} />
          </button>
        </div>
      ) : null}
    </div>
  );
}
